export default __webpack_public_path__ + "static/media/auth-bg.99e79080.png";